<template> 
    
    <router-link :to="{ name: 'newsDetail', params: { title:data[0].urlName, id: data[0].id, currentSportType: data[0].sportTypePath }}"   
        class="news__categories-card__container" v-if="data.length > 0">
        <div class="news-item first" >
            <div class="news-image relative">
                <div class="ratio-169-container"></div>
                <img
                    class="news-image--coverImg ratio-169-content"
                    :src="`${s3ImgUrl}/${data[0].coverImage}`"
                />
            </div>
                <div class="news-content">
                <div class="news-title">
                    {{ data[0].title }}
                </div>
                <div class="news-date">
                    {{ data[0].publishedOn }}
                </div>
            </div>
        </div>
    </router-link>
    <div class="news_latest-news__wrapper">

        <template  v-for="(o, index) in data" :key="index">
        <router-link :to="{ name: 'newsDetail', params: { title:o.urlName, id: o.id, currentSportType: o.sportTypePath }}"   
            class="news__categories-card__container list" 
            v-if="index > 0">
                <div class="news__categories-card__container-img">
                    <img :src="`${s3ImgUrl}/${o.coverImage}`" class="news__categories-card__container-img__coverImg">
                    <div class="news__categories-card__container-img-icon" v-if="o.videoFlag"><img src="../../../static/images/icons/icon_video_play.png"></div>
                </div>
                <div class="news__categories-card__container-desc">
                    <p class="news__categories-card__container-desc__title">{{o.title}}</p>
                    <div class="">
                        <!-- <div class=" news__categories-card__tag-wrapper" v-if="!isMobile">
                            <span class="tags" v-for="(x, index) in o.newsTags" :key="index">{{x.name}}</span>
                        </div>
                        <div v-else>
                            <span class="tags single" v-show="index === 0" v-for="(x, index) in o.newsTags" :key="index">{{x.name}}</span>
                        </div> -->
                        
                        <span class="font-s news__categories-card__time">{{o.publishedOn}}</span>
                    </div>
                </div>
            </router-link>
        </template>
    </div>
</template>

<script>
import config from '@/js/config.js'
import {mapGetters,mapActions} from 'vuex'
export default {
    props:{
        data: {
            type: Object
        },
    },
     computed:{
        ...mapGetters([              
                'isMobile',
                'currentSportType'
           ]),
    },
    data() {
        return {
            s3ImgUrl: config.s3ImgUrl,
        }
    },
}
</script>

<style lang="css" scoped src="@/assets/css/news/index.css" />
<style scoped>
.news_latest-news__wrapper{
	display: grid;
    /* gap: 24px; */
    grid-template-columns: repeat(4, calc(25% - 18px)) !important;
}
.news__categories-card__title-wrapper{
	display: flex;
	justify-content: space-between;
	border-bottom: .1rem solid var(--color-grey-60);
    /* padding-bottom: 1rem; */
    /* margin-bottom: 1rem; */
}
.news__categories-card__title{
	font-size: 0.875rem;
	font-family: var(--weight-700);
}
.news__categories-card__time{
    flex: 0 0 5rem;
    text-align: right;
    font-size: 12px;
    color: var(--color-text-default-secondary);
	letter-spacing: 0.2px;
}
.news__categories-card__tag-wrapper{
    overflow: hidden;
    height: 1.6rem;
}
.news__categories-card__container{
		
}
.news__categories-card__container-desc__title {
    height: 40px;
    font-family: var(--weight-600);
    margin-bottom: 8px;
    color: var(--color-text-default-default);
}
.news__categories-card__container-img{
	/* margin-right: 24px; */
	position: relative;
    width: 270px;
    height: 157px;
}
.news__categories-card__container-img__coverImg{
    object-fit: cover;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 8px;
}
.news__categories-card__container-img-icon{
    position: absolute;
    bottom: 0.67rem;
    left: 0.67rem;
    width: 1.87rem;
    height: 1.87rem;
}
.news__categories-card__container-img-icon img{
    width: 100%;
    height: 100%;
}
.news__categories-card__wrapper{
	display: flex;
flex-direction: column;
	column-gap: 1rem;
    row-gap: 1rem
}
.news__categories-card__container-desc{
	padding: 8px 0 0;
	display: flex;
	flex: 1;
    flex-direction: column;
    justify-content: space-between;
}
.news__categories-card__container-desc p{
	 display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
}
   
.news__categories-card__container-desc_tag{
	font-size: 10px;
}
.news__categories-card__container-desc_tag::after{
	content: '|';
	width: .1rem;
	height: 1rem;
	margin: 0 .5rem;
}
.news__categories-card__container-desc_tag:last-of-type::after {
	display: none;
}
@media(max-width: 768px) { /* for test */
    .news__categories-card__container {
        display: flex;
        align-items: center;
        /* margin-bottom: 16px; */
    }
    /* .news__categories-card__container:first-child {
        display: flex;
    }
    
    
    .news__categories-card__container:first-child 
    .news__categories-card__container-img{
		flex-shrink: 0;
		width: auto;
		height: auto;
        margin-right: 0;
        aspect-ratio: 16 / 9;
	} */
    /* .news__categories-card__container.list:first-child {
        display: block;
    } */

    .news__categories-card__container:first-child 
    .news__categories-card__container-desc p {
        margin-top: 16px;
    }
    
    .news__categories-card__wrapper{
        display: flex;
        flex-direction: column;
	}
	.news__categories-card__container-img{
		flex-shrink: 0;
		width: 118px;
		height: 79px;
        margin-right: 16px;
        aspect-ratio: 16 / 9;
	}
	.news__categories-card__container-desc{
		padding: 0;
        display: block;
	}
	.news__categories-card__title-wrapper{
		border-bottom: none;
	}
	.news__categories-card__container-desc__title{
		font-size: 14px;
        font-family: var(--weight-600);
        color: var(--color-text-default-default);
        letter-spacing: 0.64px;
        min-height: 40px;
	}
    .news__categories-card__time {
        font-size: 11px;
        color: var(--gray-500);
    }
}
</style>
<style lang="css" scoped src="@/assets/css/news/index.css" />